import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { NavigationOptions, PaginationOptions, SwiperOptions } from "swiper/types";

export default class Slider {
    target: HTMLElement;
    slider: Swiper | null = null;
    customerTrustedSliderSingle: Swiper | null = null;
    customerTrustedSliderMultiple: Swiper | null = null;
    ImageSlider: Swiper | null = null;

    navigationConfig: NavigationOptions;
    paginationConfig: PaginationOptions;

    constructor(target: HTMLElement) {
        this.target = target;

        const container = document.querySelector('.container');
        let containerStyle: CSSStyleDeclaration | null = null;
        let containerleftMargin = 0;
        let containerLeftPadding = 0;
        if (container) {
            containerStyle = window.getComputedStyle(container as HTMLElement);
            containerleftMargin = parseInt(containerStyle.marginLeft, 10);
            containerLeftPadding = parseInt(containerStyle.paddingLeft, 10);
            containerleftMargin += containerLeftPadding;
        }

        const slides = this.target.querySelectorAll('.swiper-slide');

        if (slides.length > 1) {
            if (this.target.classList.contains('swiper-customer-trust-single')) {
                this.initializeCustomerTrustSliderSingle();
            } else if (this.target.classList.contains('swiper-customer-trust-multiple')) {
                this.initializeCustomerTrustSliderMultiple();
            } else if (this.target.classList.contains('image-slider')) {
                this.initializeImageSlider(containerleftMargin);
            } else if (this.target.classList.contains('clean-slider')) {
                this.initializeCleanSlider();
            } else {
                this.initializeDefaultSlider(containerleftMargin);
            }
        }
    }

    private initializeCustomerTrustSliderSingle() {
        this.customerTrustedSliderSingle = new Swiper(this.target, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: this.target.closest('.customer-trust-section-single')?.querySelector('.swiper-button-next') as HTMLElement,
                prevEl: this.target.closest('.customer-trust-section-single')?.querySelector('.swiper-button-prev') as HTMLElement,
            },
            pagination: {
                el: this.target.querySelector('.swiper-pagination') as HTMLElement,
                clickable: true,
            },
        });
    }

    private initializeCustomerTrustSliderMultiple() {
        this.customerTrustedSliderMultiple = new Swiper(this.target, {
            modules: [Navigation, Pagination],
            slidesPerView: 3,
            autoHeight: true,
            navigation: {
                nextEl: this.target.closest('.swiper-customer-trust-multiple')?.querySelector('.swiper-button-next') as HTMLElement,
                prevEl: this.target.closest('.swiper-customer-trust-multiple')?.querySelector('.swiper-button-prev') as HTMLElement,
            },
            pagination: {
                el: this.target.querySelector('.swiper-pagination') as HTMLElement,
                clickable: true,
            },
            breakpoints: {
                300: { slidesPerView: 1, slidesOffsetBefore: 0 },
                750: { slidesPerView: 2, slidesOffsetBefore: 0 },
                1200: { slidesPerView: 3, slidesOffsetBefore: 0 },
                1400: { slidesPerView: 3 },
            },
        });
    }

    private initializeImageSlider(containerleftMargin: number) {
        this.ImageSlider = new Swiper(this.target, {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            spaceBetween: 0,
            autoHeight: true,
            slidesOffsetBefore: containerleftMargin,
            updateOnWindowResize: true,
            navigation: {
                nextEl: this.target.closest('.image-slider-section')?.querySelector('.swiper-button-next') as HTMLElement,
                prevEl: this.target.closest('.image-slider-section')?.querySelector('.swiper-button-prev') as HTMLElement,
            },
            pagination: {
                el: this.target.querySelector('.swiper-pagination') as HTMLElement,
                clickable: true,
            },
        });
    }

    private initializeDefaultSlider(containerleftMargin: number) {
        this.navigationConfig = {
            nextEl: this.target.closest('.block')?.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: this.target.closest('.block')?.querySelector('.swiper-button-prev') as HTMLElement,
        };

        this.paginationConfig = {
            clickable: true,
            el: this.target.querySelector('.swiper-pagination') as HTMLElement,
            type: 'bullets'
        };

        const options: SwiperOptions = {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            autoHeight: true,
            navigation: this.navigationConfig,
            pagination: this.paginationConfig,
            updateOnWindowResize: true,
            breakpoints: {
                300: { slidesPerView: 1, slidesOffsetBefore: 0 },
                750: { slidesPerView: 2, slidesOffsetBefore: 0},
                1200: { slidesPerView: 3.5, slidesOffsetBefore: 0},
                1400: { slidesPerView: 3.5, slidesOffsetBefore: containerleftMargin},
                1900: { slidesPerView: 4, slidesOffsetBefore: containerleftMargin},
            },
        };

        this.slider = new Swiper(this.target, options);
    }

    private initializeCleanSlider() {
        this.navigationConfig = {
            nextEl: this.target.closest('.block')?.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: this.target.closest('.block')?.querySelector('.swiper-button-prev') as HTMLElement,
        };

        this.paginationConfig = {
            clickable: true,
            el: this.target.querySelector('.swiper-pagination') as HTMLElement,
            type: 'bullets'
        };

        const options: SwiperOptions = {
            modules: [Navigation, Pagination],
            autoHeight: true,
            navigation: this.navigationConfig,
            pagination: this.paginationConfig,
            updateOnWindowResize: true,
        };

        this.slider = new Swiper(this.target, options);
    }
}
